import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import editImg from "../../assets/img/feedback-icon.png"
const ActionFeedback = ({to,onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
     <img src={editImg} style={{width:32}} /> {children}
    </Link>
  );
};

ActionFeedback.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionFeedback.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionFeedback;
